// extracted by mini-css-extract-plugin
module.exports = {"cp-terms":"styles_cp-terms__3_biU"};